import { api, requireAccount, withAccount } from "./core";

// Propagation Effect — the galaxy-facing read of the MCP propagation closed-loop.
// AI agents record which survival-proven anchor they built a module ON
// (record_propagation_receipt over MCP); this read measures — from git-sourced
// module survival — whether that code HELD. Non-personal: module + anchor paths
// and counts only, never a person (no disclosure surface).

// One recorded receipt with its git-measured verdict — did the module the agent
// built on this anchor hold?
export interface PropagationReceipt {
  repo_name: string;
  module_path: string;
  anchor_module_path: string; // "" when no declared anchor
  write_count: number;
  baseline_survival: number; // 0..100, frozen at first record
  current_survival: number; // 0..100, current observation
  verdict: "survived" | "collapsed" | "pending";
}

// Receipts aggregated by the anchor built on — "which anchors actually transfer
// in THIS codebase". transfer_rate = survived / (survived + collapsed); pending
// receipts count toward `receipts` but not the rate. Sorted rate DESC server-side.
export interface AnchorTransfer {
  anchor_module_path: string;
  receipts: number;
  survived: number;
  collapsed: number;
  transfer_rate: number; // 0..1
}

export interface PropagationReceiptsResponse {
  receipts: PropagationReceipt[];
  anchor_transfer: AnchorTransfer[];
}

export const propagationApi = {
  // Whole galaxy — no module/anchor filter. Empty until an AI agent records
  // receipts over MCP (the common early state); the card renders that as a
  // normal empty state, not an error.
  receipts: (accountLogin: string) =>
    api.get<PropagationReceiptsResponse>(
      withAccount("/galaxy/propagation-receipts", requireAccount(accountLogin, "propagationApi.receipts")),
    ),
};
